export const TagBrowserTabs = {
    Master: "Master",
    Source: "Source",
    Recent: "Recent",
}